import request from '../http/index';
import { API_ROOT, API_AUTH, Api } from '../constants/ApiConfig';

const API = {
  Code() {
    return request(`${API_AUTH}${Api.Code}`, {
      method: 'get',
    });
  },
  Login(data) {
    return request(`${API_AUTH}${Api.Login}`, {
      method: 'post',
      data,
    });
  },
  Logout() {
    return request(`${API_AUTH}${Api.Logout}`, {
      method: 'post',
    });
  },
  menusList(data) {
    return request(`${API_ROOT}${Api.Menus}`, {
      method: 'get',
      params: data,
    });
  },
  menusTree(data) {
    return request(`${API_ROOT}${Api.MenusTree}`, {
      method: 'get',
      params: data,
    });
  },
  menusBuild(data) {
    return request(`${API_ROOT}${Api.MenusBuild}`, {
      method: 'get',
      params: data,
    });
  },
  menusAdd(data) {
    return request(`${API_ROOT}${Api.Menus}`, {
      method: 'post',
      data,
    });
  },
  menusUpdate(id, data) {
    return request(`${API_ROOT}${Api.Menus}/${id}`, {
      method: 'put',
      data,
    });
  },
  menusDel(id) {
    return request(`${API_ROOT}${Api.Menus}/${id}`, {
      method: 'delete',
    });
  },
  dictionary(data) {
    return request(`${API_ROOT}/devices/dictionary`, {
      method: 'get',
    });
  },
  accountsList(data) {
    return request(`${API_ROOT}${Api.Account}`, {
      method: 'get',
      params: data,
    });
  },
  accountsAdd(data) {
    return request(`${API_ROOT}${Api.Account}`, {
      method: 'post',
      data,
    });
  },
  accountsUpdate(id, data) {
    return request(`${API_ROOT}${Api.Account}/${id}`, {
      method: 'put',
      data,
    });
  },
  accountsDel(id) {
    return request(`${API_ROOT}${Api.Account}/${id}`, {
      method: 'delete',
    });
  },

  permissionsList(data) {
    return request(`${API_ROOT}${Api.Permissions}`, {
      method: 'get',
      params: data,
    });
  },
  permissionsTree() {
    return request(`${API_ROOT}${Api.PermissionsTree}`, {
      method: 'get',
    });
  },
  permissionsAdd(data) {
    return request(`${API_ROOT}${Api.Permissions}`, {
      method: 'post',
      data,
    });
  },
  permissionsUpdate(id, data) {
    return request(`${API_ROOT}${Api.Permissions}/${id}`, {
      method: 'put',
      data,
    });
  },
  permissionsDel(id) {
    return request(`${API_ROOT}${Api.Permissions}/${id}`, {
      method: 'delete',
    });
  },
  rolesList(data) {
    return request(`${API_ROOT}${Api.Roles}`, {
      method: 'get',
      params: data,
    });
  },
  rolesTree(data) {
    return request(`${API_ROOT}${Api.RolesTree}`, {
      method: 'get',
      params: data,
    });
  },
  rolesAllList(data) {
    return request(`${API_ROOT}${Api.Roles}`, {
      method: 'get',
      params: data,
    });
  },
  rolesAdd(data) {
    return request(`${API_ROOT}${Api.Roles}`, {
      method: 'post',
      data,
    });
  },
  rolesUpdate(id, data) {
    return request(`${API_ROOT}${Api.Roles}/${id}`, {
      method: 'put',
      data,
    });
  },
  rolesMenuUpdate(id, data) {
    return request(`${API_ROOT}${Api.Roles}/${id}/menu`, {
      method: 'put',
      data,
    });
  },
  rolesPermissionUpdate(id, data) {
    return request(`${API_ROOT}${Api.Roles}/${id}/permission`, {
      method: 'put',
      data,
    });
  },
  rolesDel(id) {
    return request(`${API_ROOT}${Api.Roles}/${id}`, {
      method: 'delete',
    });
  },
  setPassword(newPassword, oldPassword) {
    return request(`${API_ROOT}${Api.Password}/${newPassword}/${oldPassword}`, {
      method: 'post',
    });
  },
  resetPassword(id) {
    return request(`${API_ROOT}/sys/users/resetPass/${id}`, {
      method: 'post',
    });
  },
  resourcesList(data) {
    return request(`${API_ROOT}${Api.Resources}`, {
      method: 'get',
      params: data,
    });
  },

  resourcesEdit(data) {
    return request(`/mgmtUpload${Api.Resources}/update?${data}`, {
      method: 'post',
    });
  },
  resourcesDel(id) {
    return request(`${API_ROOT}${Api.Resources}/${id}`, {
      method: 'delete',
    });
  },
  devicesList(data) {
    return request(`${API_ROOT}/devices`, {
      method: 'get',
      params: data,
    });
  },
  devicesDel(ids) {
    return request(`${API_ROOT}/devices/${ids}`, {
      method: 'delete',
    });
  },
  devicesEnabled(ids) {
    return request(`${API_ROOT}/devices/${ids}/enable`, {
      method: 'post',
    });
  },
  devicesDisabled(ids) {
    return request(`${API_ROOT}/devices/${ids}/disable`, {
      method: 'post',
    });
  },
  devicesTestList(data) {
    return request(`${API_ROOT}/test/devices`, {
      method: 'get',
      params: data,
    });
  },
  devicesTestAdd(data) {
    return request(`${API_ROOT}/test/devices`, {
      method: 'post',
      data,
    });
  },
  devicesTestDel(ids) {
    return request(`${API_ROOT}/test/devices/${ids}`, {
      method: 'delete',
    });
  },
  deviceDetailByMac(mac) {
    return request(`${API_ROOT}/devices/${mac}`, {
      method: 'get',
    });
  },
  devicesByDay(data) {
    return request(`${API_ROOT}/statistics/devices/daily`, {
      method: 'get',
      params: data,
    });
  },
  devicesByWeek(data) {
    return request(`${API_ROOT}/statistics/devices/weekly`, {
      method: 'get',
      params: data,
    });
  },
  devicesByMonth(data) {
    return request(`${API_ROOT}/statistics/devices/monthly`, {
      method: 'get',
      params: data,
    });
  },

  devicesAdd(data) {
    return request(`${API_ROOT}/statistics/devices/add`, {
      method: 'get',
      params: data,
    });
  },
  devicesActive(data) {
    return request(`${API_ROOT}/statistics/devices/active`, {
      method: 'get',
      params: data,
    });
  },
  devicesCountsList() {
    return request(`${API_ROOT}/devices/count/list`, {
      method: 'get',
    });
  },
  devicesCounts(data) {
    return request(`${API_ROOT}/devices/count`, {
      method: 'get',
      params: data,
    });
  },
  devicesUpload(data) {
    return request(`${API_ROOT}/devices/import`, {
      method: 'post',
      data,
    });
  },
  devicesLog(data) {
    return request(`${API_ROOT}/device/log`, {
      method: 'get',
      params: data,
    });
  },
  devicesLogDel(id) {
    return request(`${API_ROOT}/device/log/${id}`, {
      method: 'delete',
    });
  },
  devicesExport(data) {
    return request(`${API_ROOT}/device/batch/export/ap0Mac`, {
      method: 'get',
      params: data,
    });
  },
  errorLog(data) {
    return request(`${API_ROOT}/device/error/log`, {
      method: 'get',
      params: data,
    });
  },
  errorLogDel(id) {
    return request(`${API_ROOT}/device/error/log/${id}`, {
      method: 'delete',
    });
  },
  logConfigList(data) {
    return request(`${API_ROOT}/config/list`, {
      method: 'get',
      params: data,
    });
  },
  logConfigAdd(data) {
    return request(`${API_ROOT}/config`, {
      method: 'post',
      data,
    });
  },
  logConfigEdit(id, data) {
    return request(`${API_ROOT}/config/${id}`, {
      method: 'put',
      data,
    });
  },
  logConfigDel(id) {
    return request(`${API_ROOT}/config/${id}`, {
      method: 'delete',
    });
  },
  devicesBatchCustoms(data) {
    return request(`${API_ROOT}/device/batch/customs`, {
      method: 'get',
      params: data,
    });
  },
  devicesBatchNo(custom) {
    return request(`${API_ROOT}/device/batch/batches?custom=${custom}`, {
      method: 'get',
    });
  },
  devicesBatchList(data) {
    return request(`${API_ROOT}/device/batch/list`, {
      method: 'get',
      params: data,
    });
  },
  devicesBatchModel(data) {
    return request(`${API_ROOT}/device/batch/productModel`, {
      method: 'get',
      params: data,
    });
  },
  devicesBatchDetail(data) {
    return request(`${API_ROOT}/device/batch/detail`, {
      method: 'get',
      params: data,
    });
  },
  customerList(data) {
    return request(`${API_ROOT}/customer/list`, {
      method: 'get',
      params: data,
    });
  },
  customerAdd(data) {
    return request(`${API_ROOT}/customer`, {
      method: 'post',
      data,
    });
  },
  customerEdit(id, data) {
    return request(`${API_ROOT}/customer/${id}`, {
      method: 'put',
      data,
    });
  },
  customerDel(id) {
    return request(`${API_ROOT}/customer/${id}`, {
      method: 'delete',
    });
  },
  onlineLogList(mac, data) {
    return request(`${API_ROOT}/devices/${mac}/online/log`, {
      method: 'get',
      params: data,
    });
  },
  devicesModels(data) {
    return request(`${API_ROOT}/devices/models`, {
      method: 'get',
      params: data,
    });
  },
  exportMac(data) {
    return request(`${API_ROOT}/device/batch/export/ap0Mac`, {
      method: 'get',
      params: data,
    });
  },
  batchRemarks(data) {
    return request(`${API_ROOT}/device/batch/update/remarks`, {
      method: 'put',
      data,
    });
  },
};
export default API;
